import React from "react";
export default class SVG extends React.Component {
  render() {
    return <svg viewBox="0 0 33 53" xmlns="http://www.w3.org/2000/svg" fill="currentColor" {...this.props}><title>broken segment</title><path d="M21 12.4V2.8L23.8 0H33v12.4L27 18zm0 35v-9.6l2.8-2.8H33v12.4L27 53zM0 17h2v9.8H0zM0 4.5v8.3h2V6.5h13v-2zm2 33.1v-6.3H0v7.1L6.6 45H15v-2H7.4z" /></svg>;
  }

}


// WEBPACK FOOTER //
// ./src/icons/segment-broken.inline.svg